import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Dashboard/Sidebar';
import Header from '../../components/Dashboard/Header';
import Footer from '../../components/Dashboard/Footer';
import UploadFiles from '../../components/Dashboard/UploadFiles';

const AnalyticsDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeSidebarItem, setActiveSidebarItem] = useState(1);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const isLargeScreen = windowWidth >= 992;

  useEffect(() => {
        document.title = "DCode | Adhoc code quality";
      }, []);

  // Get sidebar width based on its state
  const getSidebarWidth = () => {
    if (!sidebarOpen) return '0px';
    return sidebarCollapsed ? '80px' : '280px';
  };

  const handleSidebarItemClick = (index) => {
    setActiveSidebarItem(index);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setSidebarOpen(window.innerWidth >= 992);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleUserDropdown = () => setUserDropdownOpen(!userDropdownOpen);

  // Listen for sidebar collapse state changes
  const handleSidebarCollapseChange = (collapsed) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header with dynamic left margin */}
      <div
        style={{
          marginLeft: isLargeScreen ? getSidebarWidth() : '0px',
          transition: 'margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1030
        }}
      >

        <Header
          sidebarOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          isCollapsed={sidebarCollapsed}
          userDropdownOpen={userDropdownOpen}
          toggleUserDropdown={toggleUserDropdown}
          pageTitle="Code quality report (adhoc)"
        />
      </div>

      {/* Sidebar with collapse callback */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        activeItem={activeSidebarItem}
        onItemClick={handleSidebarItemClick}
        onCollapseChange={handleSidebarCollapseChange}
      />

      {/* Mobile overlay */}
      {sidebarOpen && !isLargeScreen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1040 }}
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Main content with dynamic margin */}
      <main
        style={{
          marginLeft: isLargeScreen ? getSidebarWidth() : '0px',
          paddingTop: '70px',
          transition: 'margin-left 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          minHeight: 'calc(100vh - 140px)'
        }}
      >
        <div className="container-fluid p-4">
          <UploadFiles
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
          />
        </div>
      </main>

      {/* Footer */}

      <Footer sidebarOpen={sidebarOpen} />
    </div>
  );
};

export default AnalyticsDashboard;